import { useEffect, useState } from "react";

// Heda Platform mode (REACT_APP_PLATFORM=1): the app runs under a sub-path
// of the platform's domain (PUBLIC_URL, e.g. /visualiser), sign-in and
// sign-out go through the platform, and AI credits come from its wallet.
// Without the env the app behaves exactly as it does standalone.

export const PLATFORM = process.env.REACT_APP_PLATFORM === "1";

// "" standalone, "/visualiser" under the platform. For public/ assets.
export const BASE = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

export const TOP_UP_URL = "/workspace/credits";

// The one-minute pass the platform puts in the URL hash when it opens the app.
export function takePlatformToken() {
  const m = /[#&]platform_token=([^&]+)/.exec(window.location.hash || "");
  if (!m) return null;
  // Strip it at once: it is single use and must not stay in history.
  window.history.replaceState(null, "", window.location.pathname + window.location.search);
  return decodeURIComponent(m[1]);
}

export function goToPlatformLogin() {
  const here = window.location.pathname + window.location.search;
  window.location.assign(`/login?next=${encodeURIComponent(here)}`);
}

let helpLoaded = false;
export function loadHelpWidget() {
  if (!PLATFORM || helpLoaded) return;
  helpLoaded = true;
  const s = document.createElement("script");
  s.src = "/help-widget.js";
  s.defer = true;
  document.body.appendChild(s);
}

// The header logo: the workspace's own logo on the platform when it has one
// (announced by /help-widget.js), else the Heda logo.
export function BrandLogo(props) {
  const [logo, setLogo] = useState(() => (PLATFORM && window.__hedaBrand?.logo) || null);
  useEffect(() => {
    if (!PLATFORM) return undefined;
    const on = (e) => setLogo(e.detail?.logo || null);
    window.addEventListener("heda-brand", on);
    return () => window.removeEventListener("heda-brand", on);
  }, []);
  return <img src={logo || `${BASE}/heda-logo.png`} {...props} />;
}
